import { FadeIn, ChapterHeading } from './Reveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useLang } from '../i18n/LangContext';

export const FAQ = () => {
  const { t } = useLang();
  const FAQ_ITEMS = t.faq.items;
  return (
  <section id="faq" data-testid="faq-section" className="bg-krug-mist py-24 md:py-32">
    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <ChapterHeading number="11" eyebrow={t.faq.eyebrow} title={t.faq.title} align="center" dark={false} />
      <FadeIn delay={0.15} className="mt-12">
        <Accordion type="single" collapsible data-testid="faq-accordion" className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-krug-navy/10 bg-white px-6 data-[state=open]:border-krug-teal/60 transition-colors duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-base md:text-lg font-bold text-krug-navy hover:text-krug-teal hover:no-underline transition-colors duration-300"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-5 text-sm md:text-base text-slate-600 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeIn>
    </div>
  </section>
  );
};
